import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import { decideNaConta } from 'dashboard/helper/escopos';
import wootConstants from 'dashboard/constants/globals';

class AudioNotificationStore {
  constructor(store) {
    this.store = store;
  }

  hasUnreadConversation = () => {
    const mineConversation = this.store.getters.getMineChats({
      assigneeType: 'me',
      status: 'open',
    });

    return mineConversation.some(conv => conv.unread_count > 0);
  };

  isMessageFromPendingConversation = (message = {}) => {
    const { conversation_id: conversationId } = message || {};
    if (!conversationId) return false;

    const activeConversation =
      this.store.getters.getConversationById(conversationId);
    return activeConversation?.status === wootConstants.STATUS_TYPE.PENDING;
  };

  isMessageFromCurrentConversation = message => {
    return this.store.getters.getSelectedChat?.id === message.conversation_id;
  };

  // ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, quem atende conversas é quem tem o
  // `conversations:participating`; desligada, as permissões, como hoje.
  hasConversationPermission = user => {
    const currentAccountId = this.store.getters.getCurrentAccountId;
    return decideNaConta(
      user,
      currentAccountId,
      'conversations:participating',
      () => {
        // Get the user permissions for the current account
        const userPermissions = getUserPermissions(user, currentAccountId);
        // Check if the user has the required permissions
        return [...ROLES, ...CONVERSATION_PERMISSIONS].some(permission =>
          userPermissions.includes(permission)
        );
      }
    );
  };
}

export default AudioNotificationStore;
